export default __webpack_public_path__ + "static/media/african.8eb486c6.svg";